
  import { defineComponent, PropType } from 'vue';

  import { getYearHalfQuarterMonthTree } from '@/common/utils/options';

  import { getSortedYearHalfQuarterMonthPeriods } from '@/modules/ved/utils/fts/periods';

  import FTSPeriodField from '../FTSPeriodField.vue';

  export default defineComponent({
    name: 'FTSMonthlyPeriodField',
    components: { FTSPeriodField },
    props: {
      modelValue: {
        type: Object as PropType<string[]>,
        required: true,
      },
      disabled: {
        type: Boolean,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      periodAccessor: {
        get() {
          return this.modelValue;
        },
        set(newValue: string[]) {
          this.$emit('update:modelValue', getSortedYearHalfQuarterMonthPeriods(newValue));
        },
      },
      getOptions() {
        return getYearHalfQuarterMonthTree(2001);
      },
    },
  });
